import { Component, inject } from '@angular/core';

import { NewAccountComponent } from '../new-account.component';

@Component({
  selector: 'app-new-account-mobile-view',
  templateUrl: './new-account-mobile-view.component.html',
  styleUrls: ['../shared-styles/new-account-device-view.component.scss'],
  standalone: false,
})
export class NewAccountMobileViewComponent {
  public readonly newAccount = inject(NewAccountComponent);
}
